<template>
  <div v-if="chat.name" class="im-chat">
    <div v-if="chat" class="im-chat-top">
      <span>{{ chat.name }}</span>
      <a
        class="pull-right menu"
        href="javascript:;"
        @click="modal = true"
        v-if="false"
      >
        <Icon type="md-menu" />
      </a>
    </div>
    <div class="im-chat-main">
      <div class="im-chat-main-left">
        <div
          id="message-box"
          class="im-chat-main-box messages"
          @scroll="handleScrollLoad"
        >
          <div
            v-show="showBack && !showHistory"
            class="to-bottom"
            @click="handleToBottom"
          >
            回到最新位置
          </div>
          <ul class="message-list">
            <template v-for="(item, index) in messageList">
              <li
                v-if="item.ifRevoke !== '1'"
                :key="index"
                :class="{ 'im-chat-mine': item.mine, 'message-item': true }"
              >
                <a :name="item.cid"></a>
                <div class="im-chat-user">
                  <img :src="item.avatar" v-if="item.avatar" alt="头像" />
                  <Icon type="ios-contact" v-else size="40" />
                  <div v-if="item.mine" class="message-info right">
                    <i>
                      <Time :time="item.timestamp" />
                    </i>
                    <span>{{ item.username }}</span>
                  </div>
                  <div v-if="!item.mine" class="message-info">
                    <span>{{ item.username }}</span>
                    <i>
                      <Time :time="item.timestamp" />
                    </i>
                  </div>
                </div>

                <div
                  :class="['im-chat-text', { 'is-file': isFile(item.content) }]"
                >
                  <template v-if="item.mine">
                    <Dropdown
                      trigger="custom"
                      :visible="visibleList[index]"
                      placement="left"
                      @on-click="(val) => handleSelectMenu(val, item)"
                    >
                      <div
                        @contextmenu="() => handleOpenMenu(index)"
                        class="text-content"
                        @click="openImageProxy($event)"
                        v-html="formatMessage(item.content)"
                      ></div>
                      <template #list>
                        <DropdownMenu>
                          <DropdownItem name="back">撤回消息</DropdownItem>
                        </DropdownMenu>
                      </template>
                    </Dropdown>
                  </template>
                  <template v-else>
                    <div
                      @contextmenu="() => handleOpenMenu(index)"
                      class="text-content"
                      @click="openImageProxy($event)"
                      v-html="formatMessage(item.content)"
                    ></div>
                  </template>
                </div>
              </li>
              <li v-else class="im-chat-back">
                <a :name="item.cid"></a>
                {{ item.mine ? "您" : "对方" }}撤回了一条消息
              </li>
            </template>
          </ul>
        </div>
        <div class="im-chat-footer">
          <div class="im-chat-tool">
            <Icon
              type="ios-happy-outline"
              @click="showFaceBox()"
              title="表情"
            ></Icon>
            <upload-tool
              @uploadBack="uploadBack"
              title="上传图片"
            ></upload-tool>
            <Faces
              v-show="showFace"
              class="faces-box"
              @click="showFace = true"
              @insertFace="insertFace"
            ></Faces>
            <Icon type="ios-more" @click="history" title="聊天记录" />
            <!-- <Button class="history-message-btn" @click="history"
              >聊天记录
            </Button> -->
          </div>
          <textarea
            v-model="messageContent"
            class="textarea"
            @keyup.enter="mineSend()"
          ></textarea>
          <div class="im-chat-send">
            <!-- <Icon type="ios-send-outline" /> -->
            <Button @click="mineSend()" icon="ios-send-outline" :loading="!openSend">{{ openSend ? '发送':'连接建立中...' }}</Button>
          </div>
        </div>
      </div>
      <div v-if="isGroup" class="im-chat-users">
        <ul class="chat-user-list">
          <li
            v-for="(item, index) in userList"
            :key="index"
            @click="showUser(item)"
          >
            <span class="im-chat-avatar">
              <img :src="[host + item.avatar]" alt="" />
            </span>
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <Modal
      v-if="false"
      v-model="modal"
      class="user-model"
      closable
      footer-hide
      title="信息"
      width="300"
    >
      <div v-if="!isGroup">
        <UserModal :userId="chat.id"></UserModal>
      </div>
      <div v-if="isGroup">
        <p class="user-model-img">
          <img :src="chat.avatar" class="img" />
        </p>
        <p class="user-model-item">
          <label>群名称：</label>
          <span>{{ chat.name }}</span>
        </p>
      </div>
    </Modal>
    <Modal
      v-if="false"
      v-model="groupUserModel"
      class="user-model"
      closable
      footer-hide
      title="信息"
      width="300"
    >
      <UserModal :show-send="false" :userId="groupUser.id"></UserModal>
      <div class="model-footer">
        <Button @click="showChat(groupUser)">发送消息</Button>
      </div>
    </Modal>

    <Drawer
      v-show="showHistory"
      v-model="showHistory"
      :closable="true"
      class="history-message"
      title="聊天记录"
      width="60%"
    >
      <template #header>
        <div class="history-header">
          <div class="title">聊天记录</div>
          <div class="search">
            <Input
              style="border: 1px solid #eee;border-radius: 5px;overflow: hidden;"
              search
              size="small"
              border
              v-model="historyText"
              placeholder="请输入..."
              @on-search="handleSearchHistory"
            />
          </div>
        </div>
      </template>
      <history-message
        @updateMessageList="handleUpdateMessageList"
        @restSearchStatus="handleResetSearchStatus"
        :openSearch="openSearch"
        :search="historyText"
        :chat="chat"
        :showHistory="showHistory"
      ></history-message>
    </Drawer>
  </div>
</template>

<script>
import conf from "../conf";
import Faces from "./faces.vue";
import UserModal from "./userModal.vue";
import UploadTool from "./uploadTool.vue";
import HistoryMessage from "./historyMessage.vue";
import RequestUtils from "../../../utils/RequestUtils";
import {
  ChatListUtils,
  imageLoad,
  isGroupChat,
  MessageTargetType,
  transform,
} from "../../../utils/ChatUtils";
import StoreUtils from "../../../utils/StoreUtils";
import exe from "../../../static/exe.png";
import pdf from "../../../static/pdf.png";
import excel from "../../../static/excel.png";
import files from "../../../static/files.png";
import apk from "../../../static/apk.png";
import word from "../../../static/word.png";
import eventBus from "@/utils/eventBus";
let timer = null;
export default {
  components: {
    Faces,
    UserModal,
    HistoryMessage,
    UploadTool,
  },
  name: "userChat",
  data() {
    return {
      host: conf.getHostUrl(),
      count: 0,
      pageSize: 20,
      modal: false,
      groupUserModel: false,
      groupUser: {},
      // 保存各个聊天记录的map
      messageListMap: new Map(),
      messageList: [],
      messageContent: "",
      showFace: false,
      showHistory: false,
      userList: [],
      isGroup: false,
      serviceId: null,
      historyText: "",
      openSearch: false,
      visibleList: [],
      interval1: null,
      interval2: null,
      pageNo: 1,
      pageNo2: 1,
      isLoading: false,
      tempScroll: 0,
      load: false,
      tempCid: null,
      showBack: false,
      openSend:false,
    };
  },
  props: ["chat"],
  methods: {
    handleToBottom() {
      this.pageNo = 1;
      this.pageNo2 = 1;
      this.getHistoryMessage(1);
    },
    debounce(func, delay) {
      let timerId;
      return function() {
        const context = this;
        const args = arguments;

        clearTimeout(timerId);
        timerId = setTimeout(function() {
          func.apply(context, args);
        }, delay);
      };
    },
    handleScrollLoad(e) {
      this.tempScroll = e.target.scrollHeight;
      this.showBack =
        e.target.scrollTop + e.target.clientHeight <
        e.target.scrollHeight - 200;
      if (e.target.scrollTop <= 0 && !this.isLoading) {
        this.isLoading = true;
        // 下拉加载
        this.pageNo = this.pageNo + 1;
        if (this.isLoading) {
          this.getHistoryMessage(this.pageNo, "1");
        }
      } else if (
        e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight &&
        !this.isLoading
      ) {
        this.isLoading = true;
        // 加载下一个页数据
        if (this.pageNo2 <= 1) {
          return;
        } else {
          this.pageNo2 = this.pageNo2 - 1;
        }

        if (this.isLoading) {
          this.getHistoryMessage(this.pageNo2, "0");
        }
      }
    },
    handleUpdateMessageList({ pageNo, cid }) {
      this.getHistoryMessage(pageNo, "2");
      this.pageNo = pageNo;
      this.pageNo2 = pageNo;
      this.tempCid = cid;
      this.showHistory = false;
    },
    backMessage(message) {
      let param = new FormData();
      param.append("fromId", message.fromId);
      param.append("msgId", message.cid);
      RequestUtils.request(conf.getBackUrl(), param).then((res) => {
        this.getHistoryMessage(1);
        this.isLoading = true;
      });
    },
    maxMin(row, maxWait = 2) {
      const timestamp = new Date(row.timestamp).getTime();
      const now = new Date().getTime();
      const nowMin = (now - timestamp) / (60 * 1000);
      return nowMin > maxWait;
    },
    handleSelectMenu(cur, item) {
      if (this.maxMin(item)) {
        this.$Message.warning("超过两分钟的消息不可撤回");
        this.visibleList = this.visibleList.map((item) => false);
      } else {
        this.backMessage(item);
        this.visibleList = this.visibleList.map((item) => false);
      }
      // this.$set(this.visibleList, index, false)
    },
    handleOpenMenu(index) {
      this.visibleList = this.messageList.map((item) => {
        return false;
      });
      // this.visibleList[index] = true
      this.$set(this.visibleList, index, true);
    },
    handleResetSearchStatus() {
      this.openSearch = false;
    },
    handleSearchHistory() {
      this.openSearch = true;
    },
    getFileType(file) {
      return file.substring(file.lastIndexOf(".") + 1);
    },
    getTemplate(fileUrl, filename, fileIcon) {
      return `
        <div style="display:flex;cursor:pointer;background-color:#fff;padding: 5px 10px;border-radius: 5px;align-items: center;" data-url="${fileUrl}">
          <div class="img" style="width:40px;" data-url="${fileUrl}">
            <img style="width:40px;height:40px;" src="${fileIcon}" alt="" data-url="${fileUrl}" />
          </div>
          <div class="name" style="flex:1;font-size:14px;font-weight:400;padding-left:5px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;color: #333333;" data-url="${fileUrl}">${filename}</div>
        </div>
      `;
    },
    isFile(item) {
      let fileReg = /(.*?)class=(.*?message-file.*?)/g;
      return fileReg.test(item);
    },
    htmlResult(fileUrl, filename) {
      const fileType = this.getFileType(fileUrl);
      switch (fileType.toLowerCase()) {
        case "exe":
          return this.getTemplate(fileUrl, filename, exe);
        case "pdf":
          return this.getTemplate(fileUrl, filename, pdf);
        case "apk":
          return this.getTemplate(fileUrl, filename, apk);
        case "xls":
        case "xlsx":
          return this.getTemplate(fileUrl, filename, excel);
        case "doc":
        case "docx":
          return this.getTemplate(fileUrl, filename, word);
        default:
          return this.getTemplate(fileUrl, filename, files);
      }
    },
    formatMessage(v) {
      let fileReg = /(.*?)class=(.*?message-file.*?)/g;
      if (fileReg.test(v)) {
        const matchUrl = /href="([^"]*)"/;
        const matchName = /<\/i>(.*?)<\/a>/;
        const fileUrl = v.match(matchUrl)[1];
        const name = v.match(matchName)[1];
        if (fileUrl) {
          return this.htmlResult(fileUrl, name);
        }
      } else {
        return v;
      }
    },
    history() {
      this.showHistory = !this.showHistory;
    },
    uploadBack(url) {
      this.messageContent += url;
    },
    // 附件和图片点击展开
    openImageProxy: function(event) {
      let self = this;
      event.preventDefault();
      if (event.target.nodeName === "IMG" && !event.target.dataset.url) {
        self.winControl.openURL(event.target.src);
      } else if (event.target.dataset.url) {
        self.winControl.openURL(event.target.dataset.url);
      }
    },
    showChat(user) {
      let self = this;
      if (user.id !== self.$store.state.user.id) {
        let chat = ChatListUtils.resetChatList(
          self,
          user,
          conf.getHostUrl(),
          MessageTargetType.FRIEND
        );
        self.isGroup = isGroupChat(chat);
        self.$store.commit("setCurrentChat", JSON.parse(JSON.stringify(chat)));
        self.$nextTick(() => {
          imageLoad("message-box");
        });
      } else {
        self.$Message.warning("不能给自己说话哦");
      }
      self.groupUserModel = false;
    },
    showUser: function(user) {
      let self = this;
      self.groupUserModel = true;
      self.groupUser = user;
    },
    showFaceBox: function() {
      this.showFace = !this.showFace;
    },
    insertFace: function(item) {
      this.messageContent = this.messageContent + "face" + item;
      this.showFace = false;
    },
    // 本人发送信息
    mineSend() {
      let self = this;
      let currentUser = self.$store.state.user;
      let time = new Date().getTime();
      let content = self.messageContent;
      if (
        content !== "" &&
        content !== "\n" &&
        content.replace(/\s/g, "") !== ""
      ) {
        if (content.length > 2000) {
          self.$Message.warning("不能超过2000个字符");
        } else {
          let currentMessage = {
            mine: true,
            avatar: currentUser.avatar,
            username: currentUser.name,
            timestamp: time,
            content: self.messageContent,
            fromId: currentUser.id,
            chatId: self.chat.id,
            type: self.chat.type,
          };
          self.send(currentMessage);
        }
      } else {
        self.$Message.warning("不能发送空白消息");
      }
    },
    // 发送消息的基础方法
    send(message) {
      this.tempCid = null;
      let self = this;
      self.$store.commit("sendMessage", message);
      message.timestamp = self.formatDateTime(new Date(message.timestamp));
      self.$store.commit("addMessage", message);
      self.messageContent = "";

      // this.getHistoryMessage(1);
      self.messageList = self.$store.state.messageList;
      this.isLoading = true;
      // 每次滚动到最底部
      self.$nextTick(() => {
        imageLoad("message-box");
      });
    },

    initGroupChat() {
      let self = this;
      //群组聊天
      if (isGroupChat(self.chat)) {
        let param = new FormData();
        param.set("chatId", self.chat.id);
        RequestUtils.request(conf.getChatUsersUrl(), param).then((json) => {
          self.userList = json;
        });
      }
      self.isGroup = isGroupChat(self.chat);
    },

    getHistoryMessage(pageNo, type) {
      let self = this;
      if (!pageNo) {
        pageNo = 1;
      }
      let param = new FormData();
      param.set("chatId", self.chat.id);
      param.set("chatType", "0");
      param.set("fromId", self.$store.state.user.id);
      param.set("pageNo", pageNo);

      RequestUtils.request(conf.getHisUrl(), param).then((json) => {
        let list = json.messageList.map(function(element) {
          element.content = transform(element.content);
          element.timestamp = self.formatDateTime(new Date(element.timestamp));
          return element;
        });
        if (type) {
          if (type === "1") {
            if (list.length === 0) {
              return;
            }
            let arr = [...list.reverse(), ...this.$store.state.messageList];
            self.$store.commit("setMessageList", arr);
            const elem = document.querySelector("#message-box");
            this.$nextTick(() => {
              elem.scrollTo({
                top: elem.scrollHeight - this.tempScroll,
              });
            });
          } else if (type === "0") {
            if (list.length === 0) {
              return;
            }
            let arr = [...this.$store.state.messageList, ...list.reverse()];
            self.$store.commit("setMessageList", arr);
          } else if (type === "2") {
            self.$store.commit("setMessageList", list.reverse());
          }
          setTimeout(() => {
            if (self.tempCid) {
              const target = document.querySelector(
                `a[name='${self.tempCid}']`
              );
              target.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              });
            }
          }, 500);
        } else {
          self.$store.commit("setMessageList", list.reverse());
          self.$nextTick(() => {
            imageLoad("message-box");
          });
        }
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        timer = setTimeout(() => {
          self.isLoading = false;
          clearTimeout(timer);
          timer = null;
          self.tempCid = null;
        }, 1000);
        // 每次滚动到最底部
        // self.$nextTick(() => {
        //   imageLoad("message-box");
        // });
      });
    },
    getKefuList(serviceId) {
      if (!serviceId) {
        return false;
      }
      fetch(
        `${conf.getHostUrl()}/api/message/getKeFuList?bindid=${serviceId}`,
        {
          headers: {
            Authorization: "bearer " + StoreUtils.getAccessToken(),
          },
          method: "post",
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          this.$store.commit("setUserFriendList", res);
        });
    },
    listenMessage(e) {
      if (e.data.type === "im") {
        StoreUtils.setToken(e.data.content);
        RequestUtils.webSocketOperation(this);
        RequestUtils.request(conf.getInitUrl(), new FormData()).then((res) => {
          this.$store.commit("setUser", res.me);
          this.$store.commit(
            "setChatList",
            ChatListUtils.getChatList(this.$store.state.user.id)
          );
        });
      } else if (e.data.type === "service") {
        if (e.data.content) {
          if (e.data.content === "hiddenSideBar") {
            this.$store.commit("setVisibleLeftBar", false);
          } else {
            this.serviceId = e.data.content;
            if (this.serviceId) {
              this.getKefuList(this.serviceId);
            }
            if (this.interval1 || this.interval2) {
              clearInterval(this.interval1);
              clearInterval(this.interval2);
              this.interval1 = null;
              this.interval2 = null;
            }
            this.$store.commit("setVisibleLeftBar", true);
            this.interval1 = setInterval(() => {
              if (this.serviceId) {
                this.getKefuList(this.serviceId);
              }
            }, 5000);
          }
        } else {
          if (this.interval1 || this.interval2) {
            clearInterval(this.interval1);
            clearInterval(this.interval2);
            this.interval1 = null;
            this.interval2 = null;
          }
          this.serviceId = 2;
          if (this.serviceId) {
            this.getKefuList(this.serviceId);
          }
          this.$store.commit("setVisibleLeftBar", true);
          this.interval2 = setInterval(() => {
            if (this.serviceId) {
              this.getKefuList(this.serviceId);
            }
          }, 5000);
        }
      } else if (e.data.type === "serviceById") {
        this.serviceId = e.data.content.serviceId;
        this.$store.commit("setVisibleLeftBar", true);
        this.showChat(e.data.content.user);
      } else if (e.data.type === "filter") {
        sessionStorage.setItem("filter", e.data.content);
      } else if (e.data.type === "destroy") {
        this.$store.commit("setCurrentChat", {});
        this.$store.commit("setMessageListMap", new Map());
        // window.removeEventListener("message", this.listenMessage);
      }
    },
  },
  watch: {
    "$store.state.messageList": {
      deep: true,
      immediate: true,
      handler(val) {
        this.messageList = val;
        // this.$nextTick(() => {
        //   imageLoad("message-box");
        // });
      },
    },
    // 监听每次 chat 的变化
    chat: {
      deep: true,
      immediate: true,
      handler(val) {
        let self = this;
        self.messageList = [];
        // 从内存中取聊天信息
        // let cacheMessages = self.$store.state.messageListMap[self.chat.id];
        // if (cacheMessages) {
        //   self.$store.commit("setMessageList", cacheMessages);
        //   self.messageList = cacheMessages;
        // } else {
        //
        // }
        self.getHistoryMessage(1);
        self.$nextTick(() => {
          imageLoad("message-box");
        });
        self.initGroupChat();
      },
    },
  },
  created() {
    this.$forceUpdate();
    window.addEventListener("message", this.listenMessage);
    this.$store.commit("setCurrentChat", {});
    window.parent.postMessage(
      {
        type: "ready",
        content: "ready",
      },
      "*"
    );
  },
  mounted: function() {
    let self = this;
    eventBus.on("updateList", () => {
      self.getHistoryMessage(1);
    });
    eventBus.on("open",()=>{
     self.openSend = true
    })
    window.addEventListener("click", (e) => {
      if (!e.target.className.includes("ivu-dropdown-item")) {
        this.visibleList = this.visibleList.map((item) => false);
      }
    });
    self.initGroupChat();
  },
  beforeDestroy() {
    self.$store.commit("setCurrentChat", {});
  },
};
</script>

<style lang="scss">
@import "@/static/styles/theme";

.im-chat {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.im-chat-top {
  color: $color-default;
  font-size: 1.6rem;
  font-weight: bold;
  padding: 5px 20px;
  // background-color: #fff;
  // border-bottom: 1px solid #d8d8d8;

  .menu {
    color: $color-default;
    display: inline-block;
    padding: 0 10px;
  }
}

.user-model {
  .user-model-img {
    padding: 15px;
    text-align: center;

    img {
      border-radius: 50%;
    }
  }

  .user-model-item {
    display: flex;
    padding: 5px 0;

    label {
      flex: 2;
      font-weight: bold;
      text-align: right;
    }

    span {
      flex: 3;
    }
  }
}

.im-chat-main {
  flex: 1;
  display: flex;
  flex-direction: row;
  height: calc(100% - 40px);

  .im-chat-main-left {
    flex: 4;
    display: flex;
    flex-direction: column;

    .im-chat-main-box {
      position: relative;
      flex: 1;
      padding-top: 1rem;
      overflow-x: hidden;
      overflow-y: auto;
      .to-bottom {
        position: fixed;
        right: 20px;
        bottom: 160px;
        z-index: 99999;
        padding: 5px 10px;
        background-color: #fff;
        border-radius: 25px;
        cursor: pointer;
        font-size: 14px;
        color: rgb(39, 127, 240);
        &:hover {
          background-color: #e5e5e5;
        }
      }
    }
  }

  .message-img {
    max-width: 20rem;
  }

  .im-chat-users {
    width: 180px;
    border-left: 1px solid #cccccc;
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 0;
    }

    .chat-user-list {
      list-style: none;
      margin: 0;

      & > li {
        margin-bottom: 1rem;
        cursor: pointer;
        padding: 5px 2px;
        position: relative;

        &:hover {
          background-color: #eeeeee;

          &:after {
            content: "...";
            position: absolute;
            right: 10px;
            font-weight: bold;
          }
        }

        & > .im-chat-avatar {
          width: 3.2rem;
          height: 3.2rem;
          display: inline-block;
          vertical-align: middle;

          & > img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .messages {
    width: 100%;
    height: calc(100% - 3rem);
    overflow-y: scroll;

    ul.message-list {
      width: 100%;

      li.im-chat-back {
        font-size: 12px;
        text-align: center;
        color: #bbb9b9;

        & + .im-chat-back {
          margin-top: 10px;
        }
      }

      li.message-item {
        position: relative;
        font-size: 0;
        margin-bottom: 10px;
        padding-left: 60px;
        min-height: 68px;

        .im-chat-text {
          position: relative;
          line-height: 22px;
          margin-top: 25px;
          padding: 1rem;
          max-width: 50%;
          background-color: #ffffff;
          border-radius: 3px;
          color: #333;
          word-break: break-all;
          display: inline-block;
          vertical-align: top;
          font-size: 14px;
          box-shadow: 0 0 8px #cac8c8;

          .ivu-select-dropdown {
            z-index: 9999;
          }

          &:after {
            content: "";
            position: absolute;
            left: -10px;
            top: 13px;
            width: 0;
            height: 0;
            border-style: solid dashed dashed;
            border-color: #ffffff transparent transparent;
            overflow: hidden;
            border-width: 10px;
          }

          div.text-content {
            width: 100%;
            // white-space: pre-wrap;
            word-break: break-all;
            position: relative;
            z-index: 1;
          }

          pre {
            width: 100%;
            white-space: pre-wrap;
            word-break: break-all;
            position: relative;
            z-index: 1;

            img {
              display: block;
            }
          }
        }
      }
    }

    .im-chat-user {
      width: 4rem;
      height: 4rem;
      position: absolute;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;
      left: 3px;
      right: auto;

      .message-info {
        position: absolute;
        left: 60px;
        top: -2px;
        width: 500px;
        line-height: 24px;
        font-size: 12px;
        white-space: nowrap;
        color: #999;
        text-align: left;
        font-style: normal;

        i {
          font-style: normal;
          padding-left: 15px;
        }
      }

      .right {
        right: 0;
        text-align: right;
        left: auto;

        i {
          padding-right: 15px;
        }
      }

      img {
        width: 4rem;
        height: 4rem;
        border-radius: 100%;
      }
    }

    .im-chat-mine {
      text-align: right;
      padding-left: 0;
      padding-right: 60px;

      .im-chat-text {
        margin-left: 10px;
        text-align: left;
        background-color: $color-message-bg !important;
        color: #fff !important;
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        box-shadow: 0px 0 8px #b8b4b4;

        &.is-file {
          background-color: #fff !important;

          &::after {
            border-top-color: #fff !important;
          }
        }

        &::after {
          left: auto !important;
          right: -10px !important;
          border-top-color: $color-message-bg !important;
        }
      }

      .im-chat-user {
        left: auto;
        right: 3px;

        cite {
          left: auto;
          right: 60px;
          text-align: right;

          i {
            padding-left: 0;
            padding-right: 15px;
          }
        }

        .message-info {
          right: 60px !important;
        }
      }
    }
  }
}

.im-chat-footer {
  border-top: 1px solid $color-gray;
  height: 15rem;
  display: flex;
  flex-direction: column;

  .im-chat-tool {
    padding: 0.5rem 1rem;
    height: 3.4rem;
    position: relative;

    i {
      font-size: 2.4rem;
      cursor: pointer;
      margin-left: 1rem;
    }

    .faces-box {
      position: absolute;
      bottom: 3.8rem;
      z-index: 10;
    }

    .ivu-upload {
      display: inline-block;
    }

    .history-message-btn {
      float: right;
    }
  }

  textarea {
    border: 0;
    padding: 0.5rem;
    width: 100%;
    flex: 1;
    resize: none;
    background-color: $color-box-bg !important;

    &:focus {
      border: 0;
    }
  }

  .im-chat-send {
    height: 4rem;
    text-align: right;
    padding: 0.5rem 1rem 1rem 0;

    .ivu-icon {
      font-size: 16px;
    }
  }
}

.ivu-scroll-wrapper {
  margin: 0 !important;
}

.ivu-scroll-container {
  padding: 15px 15px 5px;
  overflow-y: visible !important;
}

/* 重新覆盖iview 里面的 model 小于768px 时候 宽度变100% 的问题 */
@media (max-width: 768px) {
  .user-model {
    .ivu-modal {
      width: 30rem !important;
      margin: 0 auto;
    }
  }
}

.history-message {
  width: 80%;
  height: calc(100% - 30px);

  .history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20%;
    .search {
      .ivu-input {
        font-size: 12px;
        color: #918c8c;
      }
    }
  }
}

.page {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0.5rem;
}

.ivu-drawer-body {
  padding: 0 !important;

  .messages {
    height: calc(100% - 3rem);
  }
}

.model-footer {
  text-align: right;
  margin: 10px;
}
</style>
